import logo from "./logo.svg";
import logo2 from "./logo2.svg";
import dashIcon from "./dash-icon.svg";
import Admin1 from "./Admin1.png";
import Admin2 from "./Admin2.svg";
import BankAdmin from "./BankAdmin.svg";
import Nonbank from "./NonBankAdmin.svg";
import notification from "./notification.svg";
import add from "./add.svg";
import plus from "./plus.svg";
import download from "./download.svg";
import checked from "./checked.svg";
import warning from "./warning.svg";
import audit from "./audit.svg";

import checkbox from "./Checkbox.svg";
import checkbox2 from "./Checkbox2.svg";
import radio from "./radiobox.svg";
import radio2 from "./radiobox2.svg";


import admins from "./admins.svg";
import institutions from "./institutions.svg";
import transactions from "./transactions.svg";
import logout from "./logout.svg";
import checka from "./checka.svg";
import checkb from "./checkb.svg";
import nav from "./navbar-1.1s-200px.svg";
import nav2 from "./nav2.svg";

export {
  logo,
  logo2,audit,
  dashIcon,
  admins,
  institutions,
  transactions,
  notification,
  logout,
  Admin1,
  Admin2,
  BankAdmin,
  Nonbank,
  add,
  plus,
  download,
  checked,
  warning,
  checka,
  checkb,
  nav,
  checkbox,
  checkbox2,
  radio,
  radio2,
  nav2
};
